/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=ea5abf6c"
import script from "./UploadDialog.vue?vue&type=script&lang=js"
export * from "./UploadDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadDialog.vue?vue&type=style&index=0&id=ea5abf6c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea5abf6c')) {
      api.createRecord('ea5abf6c', component.options)
    } else {
      api.reload('ea5abf6c', component.options)
    }
    module.hot.accept("./UploadDialog.vue?vue&type=template&id=ea5abf6c", function () {
      api.rerender('ea5abf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/UploadDialog.vue"
export default component.exports